export default __webpack_public_path__ + "static/hero_home_img_7-cbe60d57d897d04f8722c7600d68c67e.png";